(function(){
  var root=document.getElementById('zorro-pp');
  if(!root||root.dataset.init)return; root.dataset.init='1';
  function eur(n){return '€'+(Number(n)).toFixed(2).replace('.',',');}
  function money(c){return eur(c/100);}
  function $(id){return document.getElementById(id);}
  var viewingSuffix=root.dataset.viewingSuffix||'viewing now',
      cartShipping=root.dataset.cartShipping||'€6,20 straight-to-door in Finland for 1–2 pairs. Larger shinpad orders use a higher non-door rate.',
      emptyCart=root.dataset.emptyCart||'Your cart is empty',
      addedLabel=root.dataset.added||'Added to cart',
      saveLabel=root.dataset.saveLabel||'Save',
      giveawaySuccess=root.dataset.giveawaySuccess||'You’re in — check your inbox';
  function escapeHtml(value){return String(value).replace(/[&<>"']/g,function(ch){return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'})[ch];});}

  /* marquee + club bands */
  var mqItems='OUTWORK THE REST&nbsp;&nbsp;<b>✦</b>&nbsp;&nbsp;BUILT FOR FOOTBALL&nbsp;&nbsp;<b>✦</b>&nbsp;&nbsp;TRUSTED BY PRO ATHLETES&nbsp;&nbsp;<b>✦</b>&nbsp;&nbsp;14-DAY RETURNS&nbsp;&nbsp;<b>✦</b>&nbsp;&nbsp;';
  if($('zpp-mq')) $('zpp-mq').innerHTML='<span>'+mqItems+'</span><span>'+mqItems+'</span><span>'+mqItems+'</span><span>'+mqItems+'</span>';
  var clubs='VEIKKAUSLIIGA&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;YKKÖNEN&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;KAKKONEN&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;ACADEMY&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;FUTSAL&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;';
  if($('zpp-club')) $('zpp-club').innerHTML='<span>'+clubs+'</span><span>'+clubs+'</span><span>'+clubs+'</span>';

  /* ===== price state ===== */
  var nowEl=$('zpp-now'), wasEl=$('zpp-was'), saveEl=$('zpp-save'),
      ctaPrice=$('zpp-ctaprice'), sbPrice=$('zpp-sbprice');
  var state={vid:root.dataset.vid||'', price:parseFloat(root.dataset.price||'0'), was:parseFloat(root.dataset.was||'0'), qty:1};
  function setPrice(price,was){
    state.price=price; state.was=was||0;
    if(nowEl) nowEl.textContent=eur(price);
    if(wasEl){ if(was&&was>price){wasEl.style.display='';wasEl.textContent=eur(was);} else wasEl.style.display='none'; }
    if(saveEl){
      if(was&&was>price){var s=was-price;var pct=Math.round(s/was*100);saveEl.style.display='';saveEl.textContent=saveLabel+' '+eur(s)+' · −'+pct+'%';}
      else saveEl.style.display='none';
    }
    var disp=eur(price);
    if(ctaPrice) ctaPrice.textContent=disp;
    if(sbPrice) sbPrice.textContent=disp;
  }

  /* ===== bundle tiers + size variants ===== */
  var tiers=$('zpp-tiers'), sizes=$('zpp-sizes');
  function selectedSize(){return sizes?sizes.querySelector('.size.on'):null;}
  function tierVariants(tier){
    if(!tier||!tier.dataset.variants)return [];
    try{return JSON.parse(tier.dataset.variants);}catch(e){return [];}
  }
  function tierVariant(tier){
    var size=selectedSize();
    if(tier.dataset.pack==='1'){
      return size?{id:size.dataset.vid,available:!size.disabled,price:parseFloat(size.dataset.price||tier.dataset.total),was:parseFloat(size.dataset.was||tier.dataset.was||'0')}:{id:tier.dataset.vid,available:true,price:parseFloat(tier.dataset.total),was:parseFloat(tier.dataset.was||'0')};
    }
    var variants=tierVariants(tier), option=size&&size.dataset.option;
    if(variants.length===1)return variants[0].available?variants[0]:null;
    if(option){
      var exact=variants.find(function(variant){return variant.available&&variant.title===option;});
      if(exact)return exact;
    }
    return option?null:variants.find(function(variant){return variant.available;});
  }
  function updateTierAvailability(){
    if(!tiers)return;
    tiers.querySelectorAll('.tier').forEach(function(tier){
      var available=Boolean(tierVariant(tier));
      tier.disabled=!available;
      tier.setAttribute('aria-disabled',available?'false':'true');
    });
  }
  function activateTier(tier){
    if(!tier||tier.disabled)return false;
    var variant=tierVariant(tier); if(!variant)return false;
    tiers.querySelectorAll('.tier').forEach(function(item){var active=item===tier;item.classList.toggle('on',active);item.setAttribute('aria-pressed',active?'true':'false');});
    state.vid=variant.id; state.qty=1;
    if(tier.dataset.pack==='1')setPrice(variant.price,variant.was);
    else setPrice(parseFloat(tier.dataset.total),parseFloat(tier.dataset.was||'0'));
    return true;
  }
  if(tiers){
    updateTierAvailability();
    tiers.addEventListener('click',function(e){
      var tier=e.target.closest('.tier');
      if(!tier||tier.disabled)return;
      activateTier(tier);
    });
  }

  if(sizes){
    sizes.addEventListener('click',function(e){
      var b=e.target.closest('.size'); if(!b||b.classList.contains('soon')||b.hasAttribute('disabled'))return;
      this.querySelectorAll('.size').forEach(function(s){var active=s===b;s.classList.toggle('on',active);s.setAttribute('aria-pressed',active?'true':'false');});
      if(b.dataset.vid){
        if(tiers){
          updateTierAvailability();
          var activeTier=tiers.querySelector('.tier.on');
          if(!activeTier||activeTier.disabled)activeTier=tiers.querySelector('.tier[data-pack="1"]:not(:disabled)');
          activateTier(activeTier);
        }else{
          state.vid=b.dataset.vid;
          setPrice(parseFloat(b.dataset.price),parseFloat(b.dataset.was||'0'));
        }
      }
    });
  }

  /* ===== qty stepper (non-tier products) ===== */
  var qtyInput=$('zpp-qty');
  if(qtyInput){
    var dec=$('zpp-qdec'), inc=$('zpp-qinc');
    function setQ(v){state.qty=Math.max(1,v);qtyInput.value=state.qty;}
    if(dec)dec.onclick=function(){setQ(state.qty-1);};
    if(inc)inc.onclick=function(){setQ(state.qty+1);};
    qtyInput.addEventListener('change',function(){setQ(parseInt(qtyInput.value,10)||1);});
  }

  /* ===== gallery ===== */
  var mainImg=$('zpp-main'), thumbs=$('zpp-thumbs'), mainFrame=mainImg&&mainImg.closest('.g-main'), gallerySwitch=0, galleryResize;
  function fitMainFrame(w,h,instant){
    if(!mainFrame||!w||!h)return;
    var available=mainFrame.parentElement.clientWidth, ratio=w/h;
    if(!available)return;
    var maxHeight=window.innerWidth>900?Math.max(300,Math.min(650,window.innerHeight-225)):Math.max(320,window.innerHeight*.78);
    var targetWidth=available, targetHeight=targetWidth/ratio;
    if(targetHeight>maxHeight){targetHeight=maxHeight;targetWidth=targetHeight*ratio;}
    if(instant)mainFrame.classList.add('no-motion');
    mainFrame.style.width=Math.round(targetWidth)+'px';
    mainFrame.style.height=Math.round(targetHeight)+'px';
    mainFrame.style.setProperty('--zpp-image-ratio',w+' / '+h);
    mainFrame.dataset.width=w;mainFrame.dataset.height=h;
    if(instant)requestAnimationFrame(function(){mainFrame.classList.remove('no-motion');});
  }
  function revealGalleryImage(t,full,loader,token){
    if(token!==gallerySwitch||!mainFrame||!mainImg)return;
    mainFrame.querySelectorAll('.zpp-image-ghost').forEach(function(image){image.remove();});
    var ghost=mainImg.cloneNode(false);
    ghost.removeAttribute('id');ghost.removeAttribute('fetchpriority');ghost.alt='';ghost.setAttribute('aria-hidden','true');ghost.className='zpp-image-ghost';
    mainFrame.appendChild(ghost);
    mainImg.classList.add('is-entering');
    mainImg.src=full;mainImg.alt=t.getAttribute('data-alt')||mainImg.alt;
    fitMainFrame(parseFloat(t.dataset.width)||loader.naturalWidth,parseFloat(t.dataset.height)||loader.naturalHeight,false);
    mainFrame.removeAttribute('aria-busy');
    requestAnimationFrame(function(){requestAnimationFrame(function(){mainImg.classList.remove('is-entering');ghost.classList.add('is-leaving');});});
    setTimeout(function(){if(ghost.parentNode)ghost.remove();},520);
  }
  if(mainFrame&&mainImg){
    fitMainFrame(parseFloat(mainFrame.dataset.width)||mainImg.naturalWidth,parseFloat(mainFrame.dataset.height)||mainImg.naturalHeight,true);
    window.addEventListener('resize',function(){clearTimeout(galleryResize);galleryResize=setTimeout(function(){fitMainFrame(parseFloat(mainFrame.dataset.width),parseFloat(mainFrame.dataset.height),true);},120);});
  }
  if(thumbs&&mainImg){
    var selectedThumb=thumbs.querySelector('.t.on')||thumbs.querySelector('.t');
    function clearGalleryPreview(){thumbs.querySelectorAll('.t.preview').forEach(function(x){x.classList.remove('preview');});}
    function showGalleryImage(t,persist,scrollThumb){
      if(!t)return;
      var full=t.getAttribute('data-full');
      if(!full)return;
      clearGalleryPreview();
      if(persist){
        selectedThumb=t;
        thumbs.querySelectorAll('.t').forEach(function(x){x.classList.remove('on');x.setAttribute('aria-pressed','false');});
        t.classList.add('on');t.setAttribute('aria-pressed','true');
      }else if(t!==selectedThumb){t.classList.add('preview');}
      if(scrollThumb)t.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      var token=++gallerySwitch;
      if(mainImg.src===full){if(mainFrame)mainFrame.removeAttribute('aria-busy');return;}
      var loader=new Image();
      if(mainFrame)mainFrame.setAttribute('aria-busy','true');
      loader.decoding='async';
      loader.onload=function(){
        var ready=function(){revealGalleryImage(t,full,loader,token);};
        if(loader.decode)loader.decode().catch(function(){}).then(ready);else ready();
      };
      loader.onerror=function(){if(token===gallerySwitch&&mainFrame)mainFrame.removeAttribute('aria-busy');};
      loader.src=full;
    }
    thumbs.addEventListener('click',function(e){var t=e.target.closest('.t');if(t)showGalleryImage(t,true,true);});
    thumbs.querySelectorAll('.t').forEach(function(t){
      if(window.matchMedia&&window.matchMedia('(hover: hover)').matches)t.addEventListener('mouseenter',function(){showGalleryImage(t,false,false);});
      t.addEventListener('focus',function(){showGalleryImage(t,false,false);});
    });
    thumbs.addEventListener('mouseleave',function(){clearGalleryPreview();showGalleryImage(selectedThumb,false,false);});
    thumbs.addEventListener('focusout',function(){setTimeout(function(){if(!thumbs.contains(document.activeElement)){clearGalleryPreview();showGalleryImage(selectedThumb,false,false);}},0);});
  }

  /* ===== accordions ===== */
  document.querySelectorAll('#zorro-pp .acc .q').forEach(function(q){q.onclick=function(){q.parentElement.classList.toggle('open');};});
  document.querySelectorAll('#zorro-pp .faq-item .q').forEach(function(q){q.onclick=function(){q.parentElement.classList.toggle('open');};});
  var sg=$('zpp-sizeguide');
  if(sg)sg.onclick=function(e){e.preventDefault();var it=document.querySelectorAll('#zorro-pp .acc .item')[1];if(it)it.classList.add('open');};

  /* ===== countdown + watchers ===== */
  var clock=$('zpp-clock');
  function p2(n){return(n<10?'0':'')+n;}
  function tickClock(){if(!clock)return;var d=new Date();var sec=d.getHours()*3600+d.getMinutes()*60+d.getSeconds();var rem=10800-(sec%10800);var h=Math.floor(rem/3600),m=Math.floor((rem%3600)/60),s=rem%60;clock.textContent=p2(h)+':'+p2(m)+':'+p2(s);}
  if(clock){tickClock();setInterval(tickClock,1000);}
  var watch=$('zpp-watch');
  if(watch)setInterval(function(){watch.textContent=(21+Math.floor(Math.random()*19))+' '+viewingSuffix;},5000);

  /* ===== reviews carousel ===== */
  var rt=$('zpp-rtrack');
  if(rt){ if($('zpp-rprev'))$('zpp-rprev').onclick=function(){rt.scrollBy({left:-348,behavior:'smooth'});}; if($('zpp-rnext'))$('zpp-rnext').onclick=function(){rt.scrollBy({left:348,behavior:'smooth'});}; }

  /* ===== cart drawer ===== */
  var drawer=$('zpp-drawer'), scrim=$('zpp-scrim');
  function openCart(){if(!drawer||!scrim)return;drawer.classList.add('open');scrim.classList.add('open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('zorro-cart-open');}
  function closeCart(){if(!drawer||!scrim)return;drawer.classList.remove('open');scrim.classList.remove('open');drawer.setAttribute('aria-hidden','true');document.body.classList.remove('zorro-cart-open');}
  if($('zpp-cartbtn'))$('zpp-cartbtn').addEventListener('click',function(e){e.preventDefault();refresh(true);});
  if($('zpp-close'))$('zpp-close').addEventListener('click',function(e){e.preventDefault();e.stopPropagation();closeCart();});
  if(scrim)scrim.addEventListener('click',function(e){e.preventDefault();closeCart();});
  document.addEventListener('click',function(e){if(!drawer||!drawer.classList.contains('open'))return;if(drawer.contains(e.target)||e.target.closest('#zpp-cartbtn'))return;closeCart();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});

  function renderCart(cart){
    var body=$('zpp-dbody'); if(!body)return;
    if($('zpp-dcount'))$('zpp-dcount').textContent=cart.item_count;
    if($('zpp-cartdot')){$('zpp-cartdot').textContent=cart.item_count;$('zpp-cartdot').style.display=cart.item_count>0?'':'none';}
    if($('zpp-dsubtotal'))$('zpp-dsubtotal').textContent=money(cart.total_price);
    if($('zpp-shipmsg'))$('zpp-shipmsg').textContent=cartShipping;
    if(!cart.items.length){body.innerHTML='<div style="text-align:center;padding:54px 20px;color:var(--muted);font-family:var(--mono);font-size:12px;letter-spacing:.06em;text-transform:uppercase">'+escapeHtml(emptyCart)+'</div>';return;}
    var html='';
    cart.items.forEach(function(it){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2'):'';
      html+='<div class="zd-row" data-key="'+it.key+'">'
        +(img?'<img src="'+img+'" alt="">':'<div style="width:64px;height:64px;border-radius:10px;background:var(--bg2);flex-shrink:0"></div>')
        +'<div style="flex:1;min-width:0">'
        +'<div style="font-family:var(--disp);font-style:italic;font-weight:800;font-size:15px;text-transform:uppercase;line-height:1.05">'+it.product_title+'</div>'
        +(it.variant_title&&it.variant_title!=='Default Title'?'<div style="font-family:var(--mono);font-size:10px;color:var(--muted);text-transform:uppercase;margin-top:3px">'+it.variant_title+'</div>':'')
        +'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px">'
        +'<div class="zd-q"><button data-act="dec" aria-label="Decrease">−</button><span>'+it.quantity+'</span><button data-act="inc" aria-label="Increase">+</button></div>'
        +'<span style="font-weight:700;font-size:14px">'+money(it.final_line_price)+'</span>'
        +'</div></div>'
        +'<button class="zd-x" data-act="remove" aria-label="Remove"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'
        +'</div>';
    });
    body.innerHTML=html;
  }
  function refresh(open){fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){renderCart(c);if(open)openCart();});}
  function change(key,q){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(function(r){return r.json();}).then(renderCart);}
  if($('zpp-dbody'))$('zpp-dbody').addEventListener('click',function(e){
    var b=e.target.closest('button[data-act]'); if(!b)return;
    var row=b.closest('.zd-row'), key=row.getAttribute('data-key'), cur=parseInt(row.querySelector('.zd-q span').textContent,10)||0, a=b.getAttribute('data-act');
    if(a==='inc')change(key,cur+1); else if(a==='dec')change(key,Math.max(0,cur-1)); else change(key,0);
  });

  /* ===== toast ===== */
  var toast=$('zpp-toast'), tmsg=$('zpp-toastmsg'), tHide;
  function showToast(msg){ if(!toast)return; tmsg.textContent=msg; toast.classList.add('show'); clearTimeout(tHide); tHide=setTimeout(function(){toast.classList.remove('show');},2600); }

  function addToCart(items, msg){
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json();}).then(function(){showToast(msg||addedLabel);refresh(true);})
      .catch(function(){});
  }

  /* main add-to-cart */
  function mainAdd(){ if(!state.vid)return; addToCart([{id:Number(state.vid),quantity:state.qty}],addedLabel+' · '+eur(state.price*state.qty)); }
  if($('zpp-add'))$('zpp-add').onclick=mainAdd;
  if($('zpp-sbadd'))$('zpp-sbadd').onclick=mainAdd;
  if($('zpp-buynow'))$('zpp-buynow').onclick=function(){ if(!state.vid)return; fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(state.vid),quantity:state.qty}]})}).then(function(){window.location='/checkout';}); };

  /* related add buttons */
  document.querySelectorAll('#zorro-pp .zpp-padd').forEach(function(b){
    b.onclick=function(){ if(b.dataset.vid) addToCart([{id:Number(b.dataset.vid),quantity:1}],addedLabel); };
  });

  /* giveaway */
  var gform=document.querySelector('#zorro-pp .give form');
  if(gform)gform.addEventListener('submit',function(e){e.preventDefault();showToast(giveawaySuccess);});

  /* sticky bar */
  var bar=$('zpp-sticky'), addBtn=$('zpp-add');
  if(bar&&addBtn){var sync=function(){var b=addBtn.getBoundingClientRect();bar.classList.toggle('show',b.bottom<8);};window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync);sync();}

  setPrice(state.price,state.was);
  refresh(false);
})();
